import { Lottie } from "@jugl-web/utils";
import notFoundAnimation from "./assets/not-found-animation.json";

export const TicketsNoResultsState = () => (
  <div className="flex flex-col items-center justify-center gap-8 p-6 text-center">
    <Lottie
      options={{ animationData: notFoundAnimation }}
      width={150}
      height={150}
      className="-mb-6"
    />
    <div className="flex flex-col gap-2.5">
      <h2 className="m-0 font-secondary text-2xl leading-[140%] font-medium text-black">
        No results
      </h2>
      <p className="m-0 font-secondary text-base leading-[150%] font-normal text-[#828282]">
        Try something else
      </p>
    </div>
  </div>
);
